import { React, useState } from 'react';
import PropTypes from 'prop-types';
import FiltrarAlumnos from './FiltrarAlumnos';
import ListadoAlumnos from './ListadoAlumnos';
import Loader from '../../layouts/loader/Loader';

const BuscarAlumnos = ({
  alumnos,
  setAlumnos,
  setSelectedEmails,
  selectedEmails,
  filters,
  setFilters,
  emailGroup,
  setEmailGroup,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <FiltrarAlumnos
        setAlumnos={setAlumnos}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        emailGroup={emailGroup}
        setEmailGroup={setEmailGroup}
        setSelectedEmails={setSelectedEmails}
        filters={filters}
        setFilters={setFilters}
      />
      {!isLoading ? (
        <ListadoAlumnos
          alumnos={alumnos}
          grupo={emailGroup}
          selectedEmails={selectedEmails}
          setSelectedEmails={setSelectedEmails}
        />
      ) : (
        <Loader />
      )}
    </>
  );
};

BuscarAlumnos.propTypes = {
  alumnos: PropTypes.array,
  setAlumnos: PropTypes.func,
  setSelectedEmails: PropTypes.func,
  selectedEmails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  emailGroup: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  setEmailGroup: PropTypes.func,
};

export default BuscarAlumnos;
